import React from "react";
import PropTypes from "prop-types";
import { Form, Input } from "semantic-ui-react";
import InputMask from "react-text-mask";
import Erro from "../../layouts/mensagens/Erro";
import { SecaoForm, OpcaoForm, AvisoForm } from "../../layouts/FormUI";
import { formatDocumento } from "../../../utils/formatador";

const MASCARA_CPF = [/\d/, /\d/, /\d/, ".", /\d/, /\d/, /\d/, ".", /\d/, /\d/, /\d/, "-", /\d/, /\d/];
const MASCARA_CNPJ = [/\d/, /\d/, ".", /\d/, /\d/, /\d/, ".", /\d/, /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/, "-", /\d/, /\d/];

// Campos compartilhados entre o cadastro e a edição de condomínio / sociedade / associação.
// edicao=true: o voto secreto não pode mais ser alterado (só informado).
const CamposCondominio = ({
  condominio, errors, loadingCep, ruaBairroManual, enderecoManual, edicao,
  onChange, onChangeDocumento, onChangeEndereco, onToggle,
}) => {
  const endereco = condominio.endereco || {};
  const travarRua = !ruaBairroManual && !enderecoManual;

  return (
    <>
      <SecaoForm icone="building" titulo="Identificação">
        <Form.Group>
          <Form.Field error={!!errors.nome} width={11} required>
            <label htmlFor="nome">Nome</label>
            <Input id="nome" name="nome" type="text" placeholder="Ex.: Residencial Aurora" onChange={onChange} value={condominio.nome} />
            <Erro text={errors.nome} />
          </Form.Field>
          <Form.Field error={!!errors.documento} width={5} required>
            <label htmlFor="documento">CPF ou CNPJ</label>
            <Input
              type="text"
              children={
                <InputMask
                  id="documento"
                  name="documento"
                  placeholder="CPF ou CNPJ"
                  onInput={onChangeDocumento}
                  value={formatDocumento(condominio.documento)}
                  mask={val => (val.replace(/\D/g, "").length <= 11 ? MASCARA_CPF : MASCARA_CNPJ)}
                  guide={true}
                />
              }
            />
            <Erro text={errors.documento} />
          </Form.Field>
        </Form.Group>
      </SecaoForm>

      <SecaoForm icone="map marker alternate" titulo="Endereço" descricao="Digite o CEP e preenchemos logradouro, bairro, cidade e UF.">
        <Form.Group widths={2}>
          <Form.Field error={!!errors.cep}>
            <label htmlFor="cep">CEP</label>
            <Input
              id="cep"
              loading={loadingCep}
              name="cep"
              type="text"
              placeholder="Somente números"
              onChange={onChangeEndereco}
              value={endereco.cep}
              icon={endereco.cidade ? { name: "check", color: "green" } : "search"}
            />
            <Erro text={errors.cep} />
          </Form.Field>
          <Form.Field error={!!errors.logradouro}>
            <label htmlFor="logradouro">Logradouro</label>
            <Input id="logradouro" name="logradouro" type="text" placeholder="Rua, avenida..." onChange={onChangeEndereco} value={endereco.logradouro} readOnly={travarRua} disabled={loadingCep} />
            <Erro text={errors.logradouro} />
          </Form.Field>
        </Form.Group>
        <Form.Group widths={4}>
          <Form.Field error={!!errors.bairro}>
            <label htmlFor="bairro">Bairro</label>
            <Input id="bairro" name="bairro" type="text" placeholder="Bairro" onChange={onChangeEndereco} value={endereco.bairro} readOnly={travarRua} disabled={loadingCep} />
            <Erro text={errors.bairro} />
          </Form.Field>
          <Form.Field error={!!errors.numero}>
            <label htmlFor="numero">Número</label>
            <Input id="numero" name="numero" type="text" placeholder="Número" onChange={onChangeEndereco} value={endereco.numero} />
            <Erro text={errors.numero} />
          </Form.Field>
          <Form.Field error={!!errors.cidade}>
            <label htmlFor="cidade">Cidade</label>
            <Input id="cidade" name="cidade" type="text" placeholder="Cidade" onChange={onChangeEndereco} value={endereco.cidade} readOnly={!enderecoManual} disabled={loadingCep} />
            <Erro text={errors.cidade} />
          </Form.Field>
          <Form.Field error={!!errors.uf}>
            <label htmlFor="uf">UF</label>
            <Input id="uf" name="uf" type="text" placeholder="UF" onChange={onChangeEndereco} value={endereco.uf} readOnly={!enderecoManual} disabled={loadingCep} />
            <Erro text={errors.uf} />
          </Form.Field>
        </Form.Group>
      </SecaoForm>

      <SecaoForm icone="setting" titulo="Configurações" descricao="Ajuste como as votações funcionam neste condomínio / sociedade / associação.">
        <div className="va-imp-opcoes">
          <OpcaoForm
            name="usarFracaoIdeal"
            ativa={condominio.usarFracaoIdeal}
            onChange={e => onToggle("usarFracaoIdeal", e.target.checked)}
            titulo="Usar fração ideal"
            descricao="O peso de cada unidade na votação passa a considerar a fração ideal informada no cadastro da unidade."
          />
          <OpcaoForm
            name="exibirDocsLinksVotacao"
            ativa={condominio.exibirDocsLinksVotacao}
            onChange={e => onToggle("exibirDocsLinksVotacao", e.target.checked)}
            titulo="Exibir documentos e links nos resultados"
            descricao="Mostra aos moradores, no aplicativo, os documentos e links de acesso das votações."
          />
          {edicao ? (
            <OpcaoForm
              name="votoSecreto"
              ativa={condominio.votoSecreto}
              disabled
              onChange={() => {}}
              titulo="Voto secreto"
              descricao="Definido no cadastro e não pode mais ser alterado."
            />
          ) : (
            <OpcaoForm
              name="votoSecreto"
              ativa={condominio.votoSecreto}
              onChange={e => onToggle("votoSecreto", e.target.checked)}
              titulo="Voto secreto"
              descricao="Só pode ser definido agora: depois do cadastro não é possível alterar esta opção."
            />
          )}
        </div>
        {edicao && (
          <OpcaoForm
            name="ativo"
            ativa={condominio.ativo !== false}
            onChange={e => onToggle("ativo", e.target.checked)}
            titulo="Condomínio ativo"
            descricao="Ao desativar, ele deixa de aparecer no dashboard (use o filtro Inativos para vê-lo) e pode ser reativado a qualquer momento."
          />
        )}
        {edicao && condominio.votoSecreto && (
          <AvisoForm tipo="atencao">Este cadastro foi criado com a opção de <b>voto secreto</b>.</AvisoForm>
        )}
      </SecaoForm>
    </>
  );
};

CamposCondominio.propTypes = {
  condominio: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  edicao: PropTypes.bool,
  onToggle: PropTypes.func.isRequired,
};

export default CamposCondominio;
